import { type GetterTree } from 'vuex'

import { type CoreState } from '../../types'

export const getActiveSendFormsTo: GetterTree<
  CoreState,
  unknown
>['brand/active/sendFormsTo/*'] = (state, getters) => {
  const activeBrand = getters['brand/active/*']

  return activeBrand?.sendFormsTo ?? []
}
